import React from 'react';

import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

export default class ACSaveBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };

    this.onClose = this.onClose.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
  }

  componentWillReceiveProps(props) {
    if (this.state.open !== props.isEnabled) {
      this.setState({ open: props.isEnabled });
    }
  }

  onClose = (event, reason) => {
    if (reason === 'close') this.setState({ open: false });
  };

  onClickSave = (event, reason) => {
    this.props.onSaveFunc();
    this.onClose();
  };

  render() {
    const autoHideDuration = this.props.autoHideDuration ? this.props.autoHideDuration : null;
    return (
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={this.state.open}
          autoHideDuration={autoHideDuration}
          onClose={this.onClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">Change Detected</span>}
          action={[
            <Button key="save" color="secondary" size="small" onClick={this.onClickSave}>
              SAVE !
            </Button>,
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={e => this.onClose(e, 'close')}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </div>
    );
  }
}
